/* ============================================================
   Nykaa-style mega menu — interactivity
   ------------------------------------------------------------
   - On desktop, watches the wrapping <details> for the open state
     (the existing theme already handles hover→open via
     `data-drop="mouseover"` + `details-disclosure`).
   - Activates the first panel by default and wires category tab
     buttons (mouse, keyboard, focus) to switch the active panel.
   - On mobile (≤991px), turns the snippet into a vertical
     accordion: clicking a category toggles its corresponding
     panel (only one open at a time), regardless of <details>.
   - Syncs the active state across instances when the same
     `data-block-id` appears more than once (e.g. inside both the
     desktop mega menu AND the mobile drawer).
   - Reduced motion: respects user preference.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP_BP = 992;
  var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inited = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isDesktop() { return window.innerWidth >= DESKTOP_BP; }

  function activatePanel(mega, targetId) {
    if (!mega) return;
    var panels = $$('.nykaa-mega__panel', mega);
    var navItems = $$('.nykaa-mega__nav-item', mega);
    var navBtns = $$('.nykaa-mega__nav-btn', mega);

    panels.forEach(function (p) {
      var match = p.id === targetId;
      p.classList.toggle('is-active', match);
      if (match) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });

    navItems.forEach(function (li, i) {
      var btn = navBtns[i];
      if (!btn) return;
      var match = btn.getAttribute('data-target') === targetId;
      li.classList.toggle('is-active', match);
      btn.setAttribute('aria-selected', match ? 'true' : 'false');
      btn.setAttribute('tabindex', match ? '0' : '-1');
    });
  }

  function findPanelForNav(mega, navBtn) {
    var target = navBtn.getAttribute('data-target');
    if (!target) return null;
    return $('#' + target + '-panel', mega);
  }

  function initMega(mega) {
    if (!mega || mega.__nykaaInited) return;
    mega.__nykaaInited = true;

    var blockId = mega.getAttribute('data-block-id');
    var navBtns = $$('.nykaa-mega__nav-btn', mega);
    if (!navBtns.length) return;

    var firstBtn = navBtns[0];
    var firstTarget = firstBtn.getAttribute('data-target');
    activatePanel(mega, firstTarget);

    navBtns.forEach(function (btn, idx) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = btn.getAttribute('data-target');
        var li = btn.closest('.nykaa-mega__nav-item');
        var wasActive = li && li.classList.contains('is-active');

        if (!isDesktop() && wasActive) {
          var details = btn.closest('details');
          if (details) details.removeAttribute('open');
          return;
        }

        activatePanel(mega, target);
        syncAcrossInstances(blockId, target);
      });

      btn.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') {
          e.preventDefault();
          var dir = key === 'ArrowDown' || key === 'ArrowRight' ? 1 : (key === 'ArrowUp' || key === 'ArrowLeft' ? -1 : 0);
          var next = idx + dir;
          if (key === 'Home') next = 0;
          if (key === 'End') next = navBtns.length - 1;
          if (next < 0) next = navBtns.length - 1;
          if (next >= navBtns.length) next = 0;
          var targetBtn = navBtns[next];
          if (targetBtn) {
            targetBtn.focus();
            var t = targetBtn.getAttribute('data-target');
            activatePanel(mega, t);
            syncAcrossInstances(blockId, t);
          }
        }
      });
    });
  }

  function syncAcrossInstances(blockId, target) {
    if (!blockId) return;
    $$('[data-nykaa-mega][data-block-id="' + blockId + '"]').forEach(function (other) {
      if (other.__nykaaInited) activatePanel(other, target);
    });
  }

  function watchDetails(mega) {
    var details = mega.closest('details');
    if (!details) return;

    var apply = function () {
      if (details.open) {
        mega.setAttribute('data-nykaa-state', 'open');
        mega.removeAttribute('hidden');
      } else {
        mega.removeAttribute('data-nykaa-state');
        if (!isDesktop()) mega.setAttribute('hidden', '');
      }
    };
    apply();
    details.addEventListener('toggle', apply);
  }

  function initAll() {
    var megas = $$('[data-nykaa-mega]');
    megas.forEach(function (mega) {
      initMega(mega);
      watchDetails(mega);
    });
    inited = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var pending;
  function scheduleReinit() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; initAll(); }, 60);
  }
  document.addEventListener('shopify:section:load', scheduleReinit);
  document.addEventListener('shopify:section:unload', scheduleReinit);
  document.addEventListener('shopify:block:select', scheduleReinit);

  var resizePending;
  window.addEventListener('resize', function () {
    if (resizePending) return;
    resizePending = setTimeout(function () {
      resizePending = null;
      $$('[data-nykaa-mega]').forEach(function (mega) {
        var details = mega.closest('details');
        if (!details) return;
        if (!isDesktop() && !details.open) mega.setAttribute('hidden', '');
        else mega.removeAttribute('hidden');
      });
    }, 120);
  });

  window.NykaaMegaMenu = {
    reinit: initAll,
    activate: function (blockId, target) { syncAcrossInstances(blockId, target); }
  };
})();